import React, { useState } from "react";
import { Form, Button } from "antd";

const CustomButton = ({
  label,
  type,
  htmlType,
  className,
  disabled,
  navigate,
  span_className,
  imgsrc,
  imgsrchover,
  imgalt,
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <Form.Item>
      <Button
        type={type}
        htmlType={htmlType}
        className={className}
        onClick={onClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        disabled={disabled}
      >
        <img src={isHovered ? imgsrc : imgsrchover} alt={imgalt} />
        <span className={span_className}>{label}</span>
      </Button>
    </Form.Item>
  );
};

export default CustomButton;
